import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useExtrastockOffers from './useExtrastockOffers';

const useSingleExtrastockOffer = () => {
  const { id: routeId } = useParams();
  const { singleItem, loading, contractType, statusTypes } = useExtrastockOffers(
    false,
    false,
  );

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
    contractType,
    statusTypes,
  };
};

export default useSingleExtrastockOffer;
